import { createContext } from 'react';

export const ApiContext = createContext();

export const BackendContext = createContext();

export const TasksContext = createContext();

export const UserContext = createContext();
